export default function Plus() {
  return (
    <>
      <svg
        width="16"
        height="17"
        viewBox="0 0 16 17"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <g clipPath="url(#clip0_2008_95389)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14 9.24854H2V7.99854H14V9.24854Z"
            fill="#007383"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.375 14.6235L7.375 2.62354L8.625 2.62354L8.625 14.6235L7.375 14.6235Z"
            fill="#007383"
          />
        </g>
        <defs>
          <clipPath id="clip0_2008_95389">
            <rect
              width="16"
              height="16"
              fill="white"
              transform="translate(0 0.623535)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
}
